export default function HeaderContent({ title, description }) {
  return (
    <div className="d-flex flex-column justify-content-between align-items-center pb-4">
      <h3 className="text-heading-h3 mb-0" style={{ color: "#e6ecf1" }}>
        {title}
      </h3>
      <p className="text-body-b2 mb-0" style={{ color: "#c8ced3" }}>
        {description}
      </p>
    </div>
  );
}
